import script from "./MenuList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuList.vue?vue&type=script&setup=true&lang=ts"

import "./MenuList.vue?vue&type=style&index=0&id=0373df5d&lang=scss"

const __exports__ = script;

export default __exports__